import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors,
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null,
  asyncs: {
  }
}, 'reservationSerials');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    {
      headerName: 'Serial', field: 'Serial'
    }
  ],
  Data: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clear:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }

    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.salesOrderEnquiry.reservationSerials,
  {
    Data: data => data.Data,
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  // Data: state => state.salesOrderEnquiry.reservationSerials.data.Data,
  isLoading: state => state.salesOrderEnquiry.reservationSerials.loading,
  gridOptions: state => state.salesOrderEnquiry.reservationSerials.data.gridOptions,
  Columns: state => state.salesOrderEnquiry.reservationSerials.data.Columns,
  Actions: state => state.salesOrderEnquiry.reservationSerials.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)